export const FileStatus = {
	INIT: 'init',
	ADDED: 'added',
	LOADING: 'loading',
	PENDING: 'pending',
	UPLOADING: 'uploading',
	ABORTED: 'aborted',
	COMPLETE: 'complete',
	LOAD_FAILED: 'load-failed',
	UPLOAD_FAILED: 'upload-failed',
};